module.exports = __webpack_public_path__ + "media/images/lb/066-a945364c8af92cc8072973ec10be3692.svg";